<template>
    <div slot="content">
        <form @submit.prevent="save"> 
            <div class="content-name">
                <h2 class="dp-ib">{{ title }}</h2>
                <div class="btn-wrap btn-type1 clearfix">
                    <button type="button" class="btn-size btn-gray fl_left" @click="openCustSelectModel({},'SEARCH_BUT')" v-show="pageFlag=='P1'">
                        <span class="btn-icon">
                        <i class="fas fa-search"></i>
                        </span>
                        <!-- {{$t('search')}} -->
                        {{ this.$i18n.messages[this.$store.state.locale].search }}
                    </button>
                    <button type="submit" class="btn-size btn-blue fl_left" @click="saveCust" v-show="pageFlag=='P1'">
                        <span class="btn-icon">
                        <i class="fas fa-save"></i>
                        </span>
                        <!-- {{$t('save')}} -->
                        {{ this.$i18n.messages[this.$store.state.locale].save }}
                    </button>
                    <button type="submit" class="btn-size btn-red fl_left" @click="initCust">
                        <span class="btn-icon">
                        <i class="fas fa-eraser"></i>
                        </span>
                        <!-- {{$t('init')}} -->
                        {{ this.$i18n.messages[this.$store.state.locale].init }}
                    </button>
                </div>
            </div>
        </form>
        <div class="search-form">
            <el-form size="mini" label-width="80px">
                <el-row style="margin-bottom: 0px;">
                    <el-col :span="4">
                        <el-form-item :label="$i18n.messages[$store.state.locale].custGb">
                            <el-select v-model="form.custType" disabled>
                                <el-option
                                    v-for="item in custGbList"
                                    :key="item.value"
                                    :label="item.value"
                                    :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="신고자명">
                            <el-input type="text" v-model.trim="form.custNm" @change="transVal" @keyup.native.enter="goOpen('CUSTNM')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item :label="$i18n.messages[$store.state.locale].tel">
                            <el-input type="text" v-model.trim="form.telNo" @change="transVal" @keyup.native.enter="goOpen('TELNO')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" v-show="false">
                        <el-form-item :label="$i18n.messages[$store.state.locale].mobile">
                            <el-input type="text" v-model.trim="form.hpNo" @change="transVal" @keyup.native.enter="goOpen('HPNO')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" v-show="false">
                        <el-form-item :label="$i18n.messages[$store.state.locale].sTel">
                            <el-input type="text" v-model.trim="form.boundTelNo" @change="transVal" @keyup.native.enter="goOpen('BOUNDTELNO')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item :label="$i18n.messages[$store.state.locale].siteNm">
                    <el-row>
                        <el-col :span="6">
                            <el-input type="text" v-model="form.siteNm1" @keyup.native.enter="goOpen('S1')" :readonly="siteReadOnly"></el-input>
                        </el-col>
                        <el-col :span="6">
                            <el-input type="text" v-model="form.siteNm2" @keyup.native.enter="goOpen('S2')" :readonly="siteReadOnly"></el-input>
                        </el-col>
                        <el-col :span="6">
                            <el-input type="text" v-model="form.siteNm3" @keyup.native.enter="goOpen('S3')" :readonly="siteReadOnly"></el-input>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item :label="$i18n.messages[$store.state.locale].addr" >
                    <el-col :span="5">
                        <el-col :span="8">
                            <el-input type="text" v-model="form.zipCd1" disabled></el-input>
                        </el-col>
                        <el-col :span="4">
                            <el-button type="primary" icon="el-icon-search" @click="addrOpenPopUp"></el-button>
                        </el-col>

                    </el-col>
                    <el-col :span="6">
                        <el-input type="text" v-model="form.addr1"></el-input>
                    </el-col>
                    <el-col :span="6">
                        <el-input type="text" v-model="form.addr2" @change="transVal"></el-input>
                    </el-col>
                </el-form-item>
                <el-col :span="6" v-show="false">
                    <el-form-item :label="$i18n.messages[$store.state.locale].pointCenter">
                        <el-input type="text" v-model="form.asAgentNm" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$i18n.messages[$store.state.locale].maGb">
                        <el-input type="text" v-model="form.maYn" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item :label="$i18n.messages[$store.state.locale].costYn">
                        <el-input type="text" v-model="form.payYnNm" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6" v-show="false">
                    <el-form-item :label="$i18n.messages[$store.state.locale].roomNum">
                        <el-input type="text" v-model="form.cyberRoomId" readonly></el-input>
                    </el-form-item>
                </el-col>
            </el-form>
        </div>

    </div>
</template>

<script>
import AsHistoryTab from '@/components/AS/History/index.vue';

/**
 * * mixins
 */
import lucoms from '@/mixin/lucoms';
/**
 * @author
 * * 모달팝업
 */
import CustSelectModal from '@/components/AS/SearchForm/CustSelectModal';
/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}
function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

export default {
    props: {
        search: {
            Type: Object,
            default: {
                custNm: '',
                custId: '',
                custType: 'Default', /** 디폴트 일반선택 */
                codeNm: '',
                useType: 'Y',
                inType: '',
                inTypeVal: ''
            }, //
            require: true

        }
    },
    mixins: [lucoms],
    
    data() {
        return {
            data: [],
            form: {
                    juminNo : '',
                    propensity: 'Default',
                    propensityBigo: '',
                    positionNm: '',
                    officeTelNo: '',
                    etcTelNo1: '',
                    etcTelNo2: '',
                    siteNm1 : '',
                    siteNm2 : '',
                    siteNm3 : '',
                    telNo : '',
                    telYn: '',
                    hpNo : '',
                    boundTelNo : '',
                    boundCustNm : '',
                    inType : '',
                    inTypeVal : '',
                    asAgentNm : '',
                    maYn : '',
                    payYnNm : '',
                    cyberRoomId : '',
                    zipCd1 : '',  
                    addr1 : '',
                    addr2 : '',
                    maYn : '',
                    serailNo : '',
                    smsYn: 'Y',
                    ...this.search,
                    custNm: '고객'
                },
            siteReadOnly: this.$store.state.loginInfo.groupUId !='29' ? false : true,
            title: this.$store.state.loginInfo.groupUId !='29' ? 'AS내근접수' : '대행사접수',
            pageFlag: this.$store.state.loginInfo.groupUId !='29' ? 'P1' : 'P2',
            custGbList: [{key: '1', value: '일반'}],
            areaList: [],
            agentList: []
        }
    },
    mounted() {
        console.log('search', this.search);
        this.getCustTypeCombo()
    },
    methods: {
        $dismiss() {
            this.$emit('dismiss')
            this.$parent.close()
        },
        getCustTypeCombo() {
            // 고객구분
            this.$http.get(`/api/codeMng/combo`, {params: {parentId: 10}})
                .then(response => {
                    this.custGbList = response.data || []
                    console.log('this.custGbList tttttt: ', this.custGbList)
                })
                .finally(() => {
                    this.form.custType = 'Default' /** 디폴트 일반선택 */
                });

            this.$http.get(`/api/asMng/call/topkey`, {params: {topKey: 'AreaAgent'}})
                .then(response => {
                    this.areaList = _.cloneDeep(response.data.filter(x=>x.catLvl==2)) || [];
                    this.agentList = _.cloneDeep(response.data.filter(x=>x.catLvl==3)) || [];
                    });    
        },
        goOpen(param, pObj) {

            if(this.pageFlag === 'P2'){
                // 대행사인 경우 조회실행 안함.
                return false;
            }

            let that = this;
            let vFormObj = _.cloneDeep(this.form);

            console.log('goOpen passed :', param);
            vFormObj.siteNm1 = vFormObj.siteNm1 === undefined ? '' :  vFormObj.siteNm1;
            vFormObj.siteNm2 = vFormObj.siteNm2 === undefined ? '' :  vFormObj.siteNm2;
            vFormObj.siteNm3 = vFormObj.siteNm3 === undefined ? '' :  vFormObj.siteNm3;
            vFormObj.pObj = pObj;

            if(pObj){
                vFormObj.inType = pObj.inType || '';
                vFormObj.inTypeVal = pObj.inTypeVal || '';
            }
            
            if(param === 'S1' || param === 'S2' || param === 'S3' || param === 'CUSTNM' || 
                param === 'TELNO' || param === 'HPNO' || param === 'BOUNDTELNO' || 
                param === 'SERIALNO' || param === 'ZIP' || (param != 'POPUP' && vFormObj.inType === 'IN_BOUND') ){
                   
                // 사이트명을 입력후 엔터키를 통해서 조회시 초기화 필요
                if(param != 'S1') vFormObj.siteNm1 = '';
                if(param != 'S2') vFormObj.siteNm2 = '';
                if(param != 'S3') vFormObj.siteNm3 = '';
                if(param != 'CUSTNM') {
                    vFormObj.custNm = '';
                    vFormObj.boundCustNm = '';
                } else{
                    vFormObj.boundCustNm = vFormObj.custNm || '';
                }
                if(param != 'TELNO') vFormObj.telNo = '';
                if(param != 'IN_BOUND') vFormObj.custId = '';
                if(param != 'HPNO') vFormObj.hpNo = '';
                if(param != 'BOUNDTELNO') vFormObj.boundTelNo = '';
                if(vFormObj.inType === 'IN_BOUND') vFormObj.boundTelNo = vFormObj.inTypeVal;
                
                if(param != 'SERIALNO') vFormObj.serialNo = '';
                
                if(param === 'ZIP') {
                    
                } else {
                    vFormObj.zipCd1 = '';
                    vFormObj.addr1 = '';
                    vFormObj.addr2 = '';
                }

                if(param === 'S1' || param === 'S2' || param === 'S3' || param === 'CUSTNM'){
                    vFormObj.custType = ''
                } else {
                    vFormObj.custType = 'Default';
                }
                
                vFormObj.asAgentNm  = '';
                vFormObj.maYn  = '';
                vFormObj.payYnNm  = ''; 
                vFormObj.cyberRoomId = ''; 
                vFormObj.smsYn = 'Y';
                
            }
            console.log('goOpen passed this.form.custType :', vFormObj.custType)     
            let vform = {
                companyId: this.$store.state.loginInfo.compCd || '',
                custId: vFormObj.custId || '',
                custType: vFormObj.custType || '',
                siteId: '',
                siteNm1: vFormObj.siteNm1 ? vFormObj.siteNm1 : '',
                siteNm2: vFormObj.siteNm2 ? vFormObj.siteNm2 : '',
                siteNm3: vFormObj.siteNm3 ? vFormObj.siteNm3 : '',
                boundCustNm: vFormObj.boundCustNm ? vFormObj.boundCustNm : '',
                boundTelNo: vFormObj.boundTelNo ? vFormObj.boundTelNo : '',
                telNo: vFormObj.telNo ? vFormObj.telNo : '',
                hpNo: vFormObj.hpNo ? vFormObj.hpNo : '',
                cyberRoomId: '',
                sortType: vFormObj.sortType ? vFormObj.sortType : '',
                inType: vFormObj.inType ? vFormObj.inType : '',
                inTypeVal: vFormObj.inTypeVal ? vFormObj.inTypeVal : '',
                serialNo: vFormObj.serialNo || '',
                zipCd: vFormObj.zipCd1 || '',
                page: 1,
                totalpage: 9999,
                totalcount: 9999,
                curPage: 0,
                processTime: ''
            }
            console.log('goOpen passed this.form.custType2 :', vFormObj.custType)  
            if(param === 'PAGE_INIT'){
                
                this.$parent.viewer = 'recipt'
                this.$parent.tab[0].tabCss = 'btn btn-primary'
                
                // this.$parent.changeTab('recipt')
                console.log('this.$parent.$route.path : ', this.$parent.$route.path)
                console.log('this.$parent.$route.fullPath : ', this.$parent.$route.fullPath)
                
                vFormObj.custType = 'Default' /** 디폴트 일반선택 */
                vFormObj.custId = ''
                vFormObj.custNm = '고객'
                vFormObj.siteNm1 =''
                vFormObj.siteNm2 =''
                vFormObj.siteNm3 =''
                vFormObj.telNo = ''
                vFormObj.hpNo = ''
                vFormObj.boundTelNo = ''
                vFormObj.boundCustNm = ''
                vFormObj.inType = ''
                vFormObj.inTypeVal = ''
                vFormObj.asAgentNm = ''
                vFormObj.maYn = ''
                vFormObj.payYnNm = ''
                vFormObj.zipCd1 = ''  
                vFormObj.addr1 = ''
                vFormObj.addr2 = ''
                vFormObj.maYn = ''
                vFormObj.serailNo = ''
              
                // 페이지 초기화
                vform = {
                    companyId: this.$store.state.loginInfo.compCd || '',
                    custId: '',
                    custType: 'Default', /** 디폴트 일반선택 */
                    siteId: '',
                    siteNm1: '',
                    siteNm2: '',
                    siteNm3: '',
                    boundCustNm: '',
                    boundTelNo: '',
                    telNo: '',
                    hpNo: '',
                    cyberRoomId: '',
                    sortType: '',
                    inType: '',
                    inTypeVal: '',
                    serialNo: '',
                    zipCd: '',
                    page: 1,
                    totalpage: 9999,
                    totalcount: 9999,
                    curPage: 0,
                    processTime: ''
                }

            } else if(param === 'POPUP'){
                // 고객조회팝업에 의해서 선택된 고객id로 조회하므로 나머지 전화번호값은 초기화하고, 조회후에 다시 화면에 셋팅
                vform = {
                    ...vform,
                    boundTelNo: '',
                    hpNo: '',
                    telNo: '',
                    siteNm1: '',
                    siteNm2: '',
                    siteNm3: '',

                    inType: '',
                    inTypeVal: ''
                }

            } else {
                
                // 페이지 초기화 혹은 유입경로가 (IN_BOUND,IN_CALL_ID,IN_AS_ID)인 것을 제외하고 공백으로 조회요청시는 고객조회 팝업창 표시
                if( !(vFormObj.inType === 'IN_BOUND' || vFormObj.inType === 'IN_CALL_ID' || vFormObj.inType === 'IN_AS_ID') ){
                    if(vFormObj.custNm === '' && vFormObj.telNo === '' && vFormObj.boundTelNo === '' &&
                        vFormObj.siteNm1 === '' && vFormObj.siteNm2 === '' && vFormObj.siteNm3 === '' ){

                        this.openCustSelectModel(
                            {
                                custType: vFormObj.custType,
                                eventFrom: param || '',
                                siteNm1: vFormObj.siteNm1 || '',
                                siteNm2: vFormObj.siteNm2 || '',
                                siteNm3: vFormObj.siteNm3 || '',
                                custNm: vFormObj.custNm || '',
                                telNo: this.getTelNo(param) || '',
                                hpNo: vFormObj.hpNo || '',
                                boundTelNo: vFormObj.boundTelNo || '',
                                cyberRoomId: '',
                                serialNo: vFormObj.serialNo || '',
                                zipCd: vFormObj.zipCd1 || '',
                                case: 1 // 호출위치: 로직 파악용
                            },    
                            param)

                        return false;
                    }
                }   
            }

            const vTelNo = this.getTelNo(param);

            this.$store.commit('loading');
            console.log('goOpen vform : ', vform) ;
            this.$http.post(("/api/asMng/call/callMain"), vform
                ).then(response => {
                 console.log('callMain SearchForm response.data' , vform.inType , response.data)
                //let vCustList = response.data.callCustSelPageList
                let vCustList = response.data.callCustSelItemList;
                // if(vform.inType && vform.inType != ''){
                //     vCustList = response.data.callParamCustSelPageList
                //     console.log('response ddd vCustList : ', vCustList)
                // }

                if(response.data.inTypeReturnMsg && response.data.inTypeReturnMsg != ''){
                    if(response.data.inTypeReturnMsg === 'SEARCH_CUST_POPUP'){
                        // 고객조회팝업 콜백에 의한 호출은 제외하고 
                        if(param != 'POPUP'){
                            this.openCustSelectModel(
                                    {
                                        custType: vFormObj.custType,
                                        eventFrom: param || '',
                                        siteNm1: vFormObj.siteNm1 || '',
                                        siteNm2: vFormObj.siteNm2 || '',
                                        siteNm3: vFormObj.siteNm3 || '',
                                        custNm: vFormObj.custNm || '',
                                        telNo: vTelNo || '',
                                        hpNo: vFormObj.hpNo || '',
                                        boundTelNo: vFormObj.boundTelNo || '',
                                        cyberRoomId: '',
                                        serialNo: vFormObj.serialNo || '',
                                        zipCd: vFormObj.zipCd1 || '',
                                        inTypeVal: vFormObj.inTypeVal || '',
                                        case: 3 // 호출위치: 로직 파악용
                                    }, param
                                );
                        }
                        
                    } else {
                        this.$swal({type: 'warning', text: response.data.inTypeReturnMsg});
                    }
                    
                    return false;
                } else if(vCustList && vCustList.length === 1){
                    let vSearchSerialNo = this.form.serialNo || ''; // 조회조건의 제조번호

                    const vCurInType = vFormObj.inType;
                    const vCurBoundTelNo = vFormObj.boundTelNo;
                    
                    this.form = vCustList[0];
                    this.form.smsYn = 'Y';
                    this.form.propensity = this.form.propensity ? this.form.propensity : 'Default';
                    this.form.propensityBigo = this.form.propensityBigo ? this.form.propensityBigo : '';
                    this.form.callDt = this.form.callDt ? this.form.callDt : this.$moment().format('YYYY-MM-DD HH:mm:ss');
                    this.form.juminNo = this.form.juminNo ? this.form.juminNo : '';
                    this.form.telNo = this.form.telNo ? _phone(this.form.telNo) : '';
                    this.form.hpNo = this.form.hpNo ? _phone(this.form.hpNo) : '';
                    this.form.boundTelNo = this.form.boundTelNo ? _phone(this.form.boundTelNo) : '';
                    

                    if(vSearchSerialNo != ''){
                        // 제조번호로 조회시 고객이 가진 제조번호가 여러개일경우 max로 구한 결과값의 제조번호가 다른값일수가 있음.
                        // 그래서 다른값인 경우 그냥 조회조건의 값으로 셋팅해줌.
                        if(this.form.serialNo && this.form.serialNo.indexOf(vSearchSerialNo) != -1){
                            this.form.serialNo = this.form.serialNo ? this.form.serialNo : '';
                        } else {
                            this.form.serialNo = vSearchSerialNo; 
                        }
                        
                    } else {
                        this.form.serialNo = '';
                    }
                    
                    
                    let vZipCd = ''
                    if(vCustList[0] && vCustList[0].zipCd){
                        vZipCd = vCustList[0].zipCd || ''

                        // 6자리 이상은 중간에 dash(-) 를 넣어서 데이타 관리
                        // 5자리는 그대로 표시
                        if(vZipCd.length == 6){
                            this.form.zipCd1 = vZipCd.substring(0,3) + '-' + vZipCd.substring(4)
                        } else if(vZipCd.length == 5 || vZipCd.length == 7){
                            this.form.zipCd1 = vZipCd
                        }
                    }


                } else {
                    // 고객조회팝업 콜백, 초기화버튼에 의한 호출은 제외하고 
                    if(!(param == 'POPUP' || param == 'PAGE_INIT')){
                        this.openCustSelectModel(
                            {
                                custType: vFormObj.custType,
                                eventFrom: param || '',
                                siteNm1: vFormObj.siteNm1 || '',
                                siteNm2: vFormObj.siteNm2 || '',
                                siteNm3: vFormObj.siteNm3 || '',
                                custNm: vFormObj.custNm || '',
                                telNo: vTelNo || '',
                                hpNo: vFormObj.hpNo || '',
                                boundTelNo: vFormObj.boundTelNo || '',
                                cyberRoomId: '',
                                serialNo: '',
                                zipCd: vFormObj.zipCd1 || '',
                                inTypeVal: vFormObj.inTypeVal || '',
                                case: 4 // 호출위치: 로직 파악용
                            }, param);
                    }
                }
                
                let vMaYn = ''
                let vPayYn = ''
                if(response.data.callCustSelItemList && response.data.callCustSelItemList.length > 0){
                    vMaYn = response.data.callCustSelItemList[0].maYn || ''
                    vPayYn = response.data.callCustSelItemList[0].payYn || ''
                }
                
                let maYnObj = response.data.getCatDataByParent.filter(x => x.topKey === 'MaYn' 
                                                                && x.catKey === vMaYn) || []
                
                this.form.maYn = maYnObj && maYnObj[0] ? maYnObj[0].catNm : ''    // MA구분
                
                let payYnObj = response.data.getCatDataByParent.filter(x => x.topKey === 'PayYn' 
                                                            && x.catKey === vPayYn) || []
                this.form.payYnNm = payYnObj && payYnObj[0] ? payYnObj[0].catNm : '' // 유/무상
                let changePayYnObj = response.data.getCatDataByParent.filter(x => x.topKey === 'ChangePayYn' 
                                                            && x.catKey === vPayYn) || []
                this.form.changePayYnNm = changePayYnObj && changePayYnObj[0] ? changePayYnObj[0].catNm : '' // 유/무상
                
                // console.log('cur viewer: ',this.$parent.viewer)
                // console.log('response.data.callAsCustSelPageList : ', response.data.callAsCustSelPageList )
                response.data.popHeadInfo = this.form
                that.$parent.searchContentInTab(response.data) // 현재소스(search) => view(부모) => history(다른 자식Tab)
                //that.$parent.searchAsHistory(response.data) // 현재소스(search) => view(부모) => history(다른 자식Tab)
                
                //that.$parent.history.data = response.data.callAsCustSelPageList || []
                    
                
            }).finally(() => {
                this.$store.commit('finish')

                let custTypeObj = this.custGbList.filter(x => x.key === this.form.custType) || []
                this.form.custTypeNm =  custTypeObj[0] ? custTypeObj[0].value : ''

                this.$parent.search = this.form // views에 조회조건 저장
                console.log('====vform2 : ', vform)

                if(param === 'PAGE_INIT'){
                    // 전체 조회정보 및 세션정보 초기화 : AS접수 저장후 호출됨.
                    this.$parent.$router.push('/VisitCall').catch(()=>{});
                }
            });
            
        },
        getTelNo(param){
            // 공백없는 전화번호 리턴

            let vTelNo = this.form.telNo || '';
            const vHpNo = this.form.hpNo || '';
            const vBoundNo = this.form.boundTelNo || '';
            
            if(param === 'HPNO'){
                if(vHpNo != '') vTelNo = vHpNo;
            } else if(param === 'BOUNDTELNO'){
                if(vBoundNo != '') vTelNo = vBoundNo;
            }
            
            if(vTelNo === '' && vHpNo != ''){
                vTelNo = vHpNo;
            } else if(vTelNo === '' && vBoundNo != ''){
                vTelNo = vBoundNo;
            }

            return vTelNo;
        },
        openCustSelectModel(vObj, eventFrom) {
            /** 고객조회 팝업 
             * 조회건이 0건 혹은 2건이상인 경우 팝업창 표시
             */

            let vCustType = ''
            if(eventFrom === 'S1' || eventFrom === 'S2' || eventFrom === 'S3'){
                this.form.custType = '';
            } else if(eventFrom === 'SEARCH_BUT'){
                // 조회버튼 클릭한 경우, 고객구분값이 전체조건으로 단순히 팝업창만 띄움.
                vObj = {
                    custType: '',
                    eventFrom: 'SEARCH_BUT',
                    siteNm1: '',
                    siteNm2: '',
                    siteNm3: '',
                    custNm: '',
                    telNo: '',
                    hpNo: '',
                    boundTelNo: '',
                    cyberRoomId: '',
                    serialNo: '',
                    zipCd: '',
                    inTypeVal: '',
                    case: 0 // 호출위치: 로직 파악용
                };

                vCustType = '';
            } else {
                this.form.custType = 'Default';
                vCustType = 'Default';
            }
             

            let vm = this;
           
            this.$modal.open({
                width: 800,
                component: CustSelectModal,
                parent: this,
                props: {
                    data: {
                        custType: vCustType,
                        eventFrom: eventFrom || '',
                        siteNm1: vObj.siteNm1 || '',
                        siteNm2: vObj.siteNm2 || '',
                        siteNm3: vObj.siteNm3 || '',
                        custNm: vObj.custNm || '',
                        telNo: vObj.telNo || '',
                        hpNo: vObj.hpNo || '',
                        boundTelNo: vObj.boundTelNo || '',
                        cyberRoomId: '',
                        serialNo: vObj.serialNo || '',
                        zipCd: vObj.zipCd || ''
                    }
                },
                events: {
                    close(param) {
                        console.log('close param: ', param);
                        vm.form.custNm = param.custNm;
                        vm.form.siteNm1 = param.siteNm1;
                        vm.form.siteNm2 = param.siteNm2;
                        vm.form.siteNm3 = param.siteNm3;
                        vm.form.zipCd1 = '';
                        vm.form.addr1 = '';
                        vm.form.addr2 = '';
                        vm.form.custType = param.custType;
                        vm.form.custId = param.custId;
                        vm.form.serialNo = param.serialNo;
                        
                        vm.form.telNo = param.telNo;
                            vm.form.hpNo = '';
                            vm.form.boundTelNo = '';
                            vm.goOpen('POPUP');
                    },
                }
            });
        },
        custValidate(){
            if(this.form.custType === ''){
                this.$swal({type: 'warning', text: '고객구분을 선택해 주십시오.'});
                return false
            }

            if(this.form.custNm === ''){
                this.$swal({type: 'warning', text: '신고자명을 입력해 주십시오.'});
                return false
            }

            if(this.form.telNo === '' && this.form.hpNo === '' && this.form.boundTelNo === ''){
                this.$swal({type: 'warning', text: '하나 이상의 전화번호를 입력해 주십시오.'});
                return false
            }
            
            this.form.zipCd = this.form.zipCd || '';
            this.form.zipCd1 = this.form.zipCd1 || '';

            return true
        },
        save(){
            //console.log('save func called', this.$parent, this.$parent.$refs)
            //console.log('test',this.$parent.next())
        
        },  
        saveCust(){
            /** 고객정보 저장처리 */
            if (!this.custValidate()) {
                return false          
            }

            this.$swal({
                type: 'warning',
                text: `고객정보를 저장하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {
                if (result.value) {
                    const vform0 = {
                        ...this.form,
                        zipCd: this.form.zipCd1,
                        telNo: this.form.telNo.replace(/[^0-9]/g, ''),
                        hpNo: this.form.hpNo.replace(/[^0-9]/g, ''),
                        boundTelNo: this.form.boundTelNo.replace(/[^0-9]/g, '')
                    }
                    const vform = JSON.parse(JSON.stringify(vform0))
                    
                    this.$store.commit('loading')
                    this.$http.put(_url("/api/asMng/call/saveCust"), vform)
                        .then(response => {
                            this.$swal({ type: 'success', text: '고객정보가 저장되었습니다' });
                    
                        }).catch((e) => {
                            console.error(e);
                            this.$swal({ type: 'success', text: '고객정보의 저장에 실패 했습니다.' })
                        })
                        .finally(() => {
                            this.$store.commit('finish')
                        });

                }
            });
            
        },
        initCust(){
            /** 고객정보 초기화처리 */
            
            this.$swal({
                type: 'warning',
                text: `고객정보를 초기화하시겠습니까?`,
                showCancelButton: true,
                confirmButtonText: '예',
                cancelButtonText: '아니오',
            }).then((result) => {

                sessionStorage.removeItem("asReceipt");      // AS접수제품 초기화
                sessionStorage.removeItem("asModelBreak");   // 고장증상 초기화
                this.$parent.clearReceiptTab();              // AS접수tab 초기화

                this.goOpen('PAGE_INIT');
                if (result.value) {
                    
                    this.form=
                        {
                            juminNo : '',
                            propensity: 'Default',
                            propensityBigo: '',
                            positionNm: '',
                            officeTelNo: '',
                            etcTelNo1: '',
                            etcTelNo2: '',
                            siteNm1 : '',
                            siteNm2 : '',
                            siteNm3 : '',
                            telNo : '',
                            telYn: '',
                            hpNo : '',
                            boundTelNo : '',
                            boundCustNm : '',
                            inType : '',
                            inTypeVal : '',
                            asAgentNm : '',
                            maYn : '',
                            payYnNm : '',
                            cyberRoomId : '',
                            zipCd1 : '',  
                            addr1 : '',
                            addr2 : '',
                            maYn : '',
                            serailNo : '',
                            smsYn: 'Y',
                            custNm: '고객',
                            custType: 'Default'
                        };
                    
                        this.transVal();

                    // this.$store.commit('loading')
                    // this.$http.put(_url("/api/asMng/call/saveCallAs"), vform)
                    //     .then(response => {
                    //         this.$swal({ type: 'success', text: '고객정보가 초기화되었습니다' });
                    
                    //     }).catch((e) => {
                    //         console.error(e);
                    //         this.$swal({ type: 'success', text: '고객정보의 초기화에 실패 했습니다.' })
                    //     })
                    //     .finally(() => {
                    //         this.$store.commit('finish')
                    //     });

                }
            });
        },
        addrOpenPopUp(param) {
            const vm = this;

            let vOparam = {};
            if(param === 'ZIP'){
                vOparam = {q: this.form.addr1 + ' ' + this.form.addr2}
            }

            // eslint-disable-next-line no-undef
            new daum.Postcode({
                oncomplete: (data) => {

                    var fullAddr = data.address; //최종 주소 변수
                    var extraAddr = ''; // 조합형 주소 변수
              
                    if(data.userSelectedType === 'R') {
                        if(data.bname) {
                            extraAddr += data.bname;
                        }
                        if(data.buildingName) {
                            extraAddr += (extraAddr ? ', '+ data.buildingName : data.buildingName);
                        }
                        fullAddr += (extraAddr ? ' ('+ extraAddr + ')' : '');
                    } else {
                        fullAddr = data.jibunAddress;
                    }
                    
                    vm.form.zipCd1 = data.zonecode;
                    vm.form.addr1 = fullAddr;
                    vm.form.addr2 = ''; // 초기화

                    vm.transVal();

                    if(vm.$store.state.loginInfo.groupUId =='29'){
                        // 대행사인 경우 검색된 주소로 센터 셋팅
                        // AS기사인 경우는 세션에 있는 값으로 셋팅해서 아래의 검색이 필요없음.
                        vm.reloadAsAgent(data.zonecode);
                    }
                    
                    // vm.goOpen(param);
                }
            }).open(vOparam);
        },
        async reloadAsAgent(vZipCd){
            // 지정센터 재로딩

            await this.$http.post(`/api/asMng/call/selectServiceEngineerFind`, {zipCd: vZipCd})
            .then(response => {
                
                const vEngineerFindList = response.data;
                
                let vSearch = {};
                if(vEngineerFindList && vEngineerFindList.length>0){
                    this.form.asAgentNm = vEngineerFindList[0].asAgentNm;

                    if(this.$store.state.loginInfo.groupUId =='29'){
                        // 대행사의 경우 하드코딩이어서 변경처리 안하도록 하기위해
                        vSearch = {
                            custType: this.form.custType,
                            custNm: this.form.custNm,
                            addr1: this.form.addr1,
                            addr2: this.form.addr2,
                            zipCd1: this.form.zipCd1,
                            telNo: this.form.telNo,
                            hpNo: this.form.hpNo,
                            boundTelNo: this.form.boundTelNo,
                            smsYn: this.form.smsYn
                        }

                    } else {
                        vSearch = {
                            custType: this.form.custType,
                            custNm: this.form.custNm,
                            addr1: this.form.addr1,
                            addr2: this.form.addr2,
                            zipCd1: this.form.zipCd1,
                            telNo: this.form.telNo,
                            hpNo: this.form.hpNo,
                            boundTelNo: this.form.boundTelNo,
                            smsYn: this.form.smsYn,
                            asAgentNm: this.form.asAgentNm,
                            asAgentId: vEngineerFindList[0].asAgentId,
                            areaAgent: vEngineerFindList[0].area2,
                            userId: vEngineerFindList[0].userId,
                            userNm: vEngineerFindList[0].userNm
                        }
                    }
                    
                    
                } else {

                    if(this.$store.state.loginInfo.groupUId =='29'){
                        // 대행사의 경우 하드코딩이어서 변경처리 안하도록 하기위해
                        vSearch = {
                            custType: this.form.custType,
                            custNm: this.form.custNm,
                            addr1: this.form.addr1,
                            addr2: this.form.addr2,
                            zipCd1: this.form.zipCd1,
                            telNo: this.form.telNo,
                            hpNo: this.form.hpNo,
                            boundTelNo: this.form.boundTelNo,
                            smsYn: this.form.smsYn
                        }

                    } else {
                        this.form.asAgentNm = '';
                        vSearch = {
                            custType: this.form.custType,
                            custNm: this.form.custNm,
                            addr1: this.form.addr1,
                            addr2: this.form.addr2,
                            zipCd1: this.form.zipCd1,
                            telNo: this.form.telNo,
                            hpNo: this.form.hpNo,
                            boundTelNo: this.form.boundTelNo,
                            smsYn: this.form.smsYn,
                            asAgentNm: '',
                            asAgentId: '',
                            areaAgent: '',
                            userId: '',
                            userNm: ''
                        }
                    }
                }

                this.$emit('searchChange', vSearch);
            });

        },
        transVal(){
            // 부모창에 조회조건 전달
            const vSearch = {
                custType: this.form.custType,
                custNm: this.form.custNm,
                boundCustNm: this.form.custNm,
                addr1: this.form.addr1,
                addr2: this.form.addr2,
                zipCd1: this.form.zipCd1,
                telNo: this.form.telNo,
                hpNo: this.form.hpNo,
                boundTelNo: this.form.boundTelNo
            }
            console.log('transVal start', vSearch)
            
            this.$emit('searchChange', vSearch);
                        
        }
    }
}
</script>

<style lang="scss" scoped>
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
}

</style>